import { AbstractControl, ValidationErrors } from '@angular/forms';

export function wellheadDepthAboveMudline(control: AbstractControl): ValidationErrors | null {
   const parent = control.parent;
   if (!parent) {
      return null;
   }

   const wellheadDepth = parent.get('wellheadDepth')?.value;
   const waterDepth = parent.get('waterDepth')?.value;

   if (wellheadDepth > waterDepth) {
      return { error: 'Must be above or at the mudline' };
   }

   return null;
}
